import { useEffect, useState } from "react";
import { Routes, Route } from "react-router-dom";
import Main from "./pages/main";
import Header from "./partials/Header";
import Footer from "./partials/Footer";
import WorkPayExplorer from "./pages/work-pay-explorer";
import CareerSecurity from "./pages/career-security";
import HealthWellBeing from "./pages/health-well-being";
import HouseholdInsight from "./pages/household-insight";
import LifeSatisfactionScanner from "./pages/life-satisfaction-scanner";
import BottomBar from "./components/BottomBar";
import Subtopics from "./pages/subtopics";
import Report from "./pages/report";
import Modal from "./modals";
import { useDispatch, useSelector } from "react-redux";
import SetNewPassword from "./pages/set-new-password";
import Profile from "./pages/profile";
import EmailConfirmation from "./pages/email-confirmation";
import { currentUser_req } from "./api/user.api";
import { setMeData, setSessionData } from "./redux/me.slice";
import ResetPassword from "./pages/reset-password";
import PrivacyPolicy from "./pages/privacy-policy";
import Terms from "./pages/terms";
import { getAuthToken, purgeLegacyAuthStorage } from "./utils/authToken";

function App() {
  const dispatch = useDispatch();
  const [seconds, setSeconds] = useState(0);
  const [barRemoved, setBarRemoved] = useState(false);
  const modalIds = useSelector(state => state.modal.modalIds);
  const modalData = useSelector(state => state.modal.modalData);
  const currentModalIndex = useSelector(state => state.modal.currentModalIndex);
  const user = useSelector(state => state.me?.data);

  useEffect(() => {
    let id = sessionStorage.getItem("sessionId");

    if (!id) {
      // Generate a random session ID (e.g., UUID or simple random string)
      id = Math.random().toString(36).substr(2, 9);
      sessionStorage.setItem("sessionId", id);
    }

    dispatch(setSessionData(id));
  }, []);

  // useEffect(() => {
  //   // Increase seconds every 1 second
  //   const interval = setInterval(() => {
  //     setSeconds((prev) => prev + 1);
  //   }, 1000);

  //   // Cleanup on unmount
  //   return () => clearInterval(interval);
  // }, []);

  const handleBarRemove = () => {
    setBarRemoved(true);
  };
  const getUser = async () => {
    const response = await currentUser_req();
    dispatch(setMeData(response?.user));
  };
  useEffect(() => {
    purgeLegacyAuthStorage();

    const token = getAuthToken();

    if (token) {
      getUser();
    }
  }, []);

  // Cross-tab sync: if the auth cookie disappears (e.g. logout / account
  // deletion in another tab) while this tab still thinks it's logged in,
  // clear the in-memory user as soon as this tab regains focus/visibility.
  useEffect(() => {
    const syncAuthState = () => {
      if (!getAuthToken() && user) {
        dispatch(setMeData(null));
      }
    };

    window.addEventListener("focus", syncAuthState);
    document.addEventListener("visibilitychange", syncAuthState);

    return () => {
      window.removeEventListener("focus", syncAuthState);
      document.removeEventListener("visibilitychange", syncAuthState);
    };
  }, [user, dispatch]);
  return (
    <div className="App">
      <Header />

      <Routes>
        <Route path="/" element={<Main />} />
        <Route path="/profiles" element={<Main />} />
        <Route path="/email-confirmation" element={<EmailConfirmation />} />
        {/* <Route
          path="/reset-password"
          element={<ResetPassword />}
        /> */}
        <Route path="/profiles/:profileId/topics" element={<WorkPayExplorer seconds={seconds} />} />
        <Route path="/profiles/:profileId/topics/:topicId/*" element={<Subtopics seconds={seconds} />} />
        <Route path="/career-security" element={<CareerSecurity />} />
        <Route path="/health-well-being" element={<HealthWellBeing />} />
        <Route path="/household-insight" element={<HouseholdInsight />} />
        <Route path="/life-satisfaction-scanner" element={<LifeSatisfactionScanner />} />
        <Route path="/report/:id" element={<Report />} />
        <Route path="/reset-password" element={<SetNewPassword />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms" element={<Terms />} />
      </Routes>

      <Footer />
      {!barRemoved && <BottomBar handleBarRemove={handleBarRemove} />}

      {modalIds && modalIds.length !== 0 && modalIds[currentModalIndex] && <Modal modalId={modalIds[currentModalIndex]} modalData={modalData[currentModalIndex]} />}
    </div>
  );
}

export default App;
